
<span id="freeTimeTip" style="cursor: pointer;color: blue;text-decoration: underline;top: 22px;">特惠时长说明</span>
<div class="p-yue-con">
    <div class="yue-info clearfix">
        <div class="uesdTime fl">
            <h2>{{SumUsedMinute}}</h2>
            <h5>已用（分钟）</h5>
        </div>
        <div class="remainderTime fr">
            <h2>{{SumCanUseMinute}}</h2>
            <h5>剩余（分钟）</h5>
        </div>
    </div>
</div>

<div>
{{each FreeCallInfo item}}
    {{if item.FreeCallTypeMsg != "VIP会员福利礼包" }}
        <ul style="padding: 10px 0 20px 0;">
            <li class="clearfix">
                <h5 class="fl freeCallName">{{item.FreeCallTypeMsg}}</h5>
                <p class="fr freeCallTime">剩余：<span>{{item.CanUseMinute}}分钟</span></p>
            </li>
            <li>
                <div class="layui-progress">
                    <div class="layui-progress-bar" style="background:linear-gradient(90deg,#FC5578,#FD64D9);" lay-percent="{{item.UsedMinute}} / {{item.TotalMinute}}"></div>
                </div>
            </li>
            <li class="clearfix">
                <h5 class="fl freeCallDes">已用：{{item.UsedMinute}}分钟/共{{item.TotalMinute}}分钟</h5>
                <span class="fr freeCallExpireMsg">{{item.ExpireMsg}}</span>
            </li>
        </ul>
    {{else}}
        {{if IsVIP}}
            <ul style="padding: 10px 0 20px 0;">
                <li class="clearfix">
                    <h5 class="fl freeCallName">{{item.FreeCallTypeMsg}}</h5>
                    <p class="fr freeCallTime">剩余：<span>{{item.CanUseMinute}}分钟</span></p>
                </li>
                <li>
                    <div class="layui-progress">
                        <div class="layui-progress-bar" style="background:linear-gradient(90deg,#FC5578,#FD64D9);" lay-percent="{{item.UsedMinute}} / {{item.TotalMinute}}"></div>
                    </div>
                </li>
                <li class="clearfix">
                    <h5 class="fl freeCallDes">已用：{{item.UsedMinute}}分钟/共{{item.TotalMinute}}分钟</h5>
                    <span class="fr freeCallExpireMsg">{{item.ExpireMsg}}</span>
                </li>
            </ul>
        {{/if}}
    {{/if}}
{{/each}}
</div>

{{if false}}
<div class="buyVip clearfix mt10">
    <div class="fl">
        <h4>VIP会员免费时长礼包</h4>
        <h6>开通VIP每月可获得200分钟免费时长</h6>
    </div>
    <a class="buyVipBtn fr" href="./member.html">去开通</a>
</div>
{{/if}}